<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">       
      <el-form :inline="true" class="demo-form-inline backborder1" size="small">    
		  <el-form-item>
			  <el-input placeholder="供应商名称 / 公司名称  /  联系人姓名  /  联系电话  /  开户银行 / 税率" v-model="applyquery.key" @change="applychange=true" @keyup.enter.native="getApplylists" style="width:100%"></el-input>
	      </el-form-item>   
		  <el-form-item>
		      <el-button type="primary" icon="el-icon-search" @click="getApplylists">查询</el-button>
		      <el-button type="primary" icon="el-icon-circle-plus-outline"  @click="showaddSupplierDialog=true" v-if="actionauth.base_product_supplierd_add=='true'">新增供应商</el-button>
		  </el-form-item>
      </el-form>
      <div class="backborder2" style="margin-top:10px">	  
      	  <el-table :data="applylists" v-loading="ApplyLoading">
	          <el-table-column prop="id" label="编号" width="65"></el-table-column>
	          <el-table-column prop="apply_name" label="供应商名称"></el-table-column>
	          <el-table-column prop="company" label="公司名称"></el-table-column>
	          <el-table-column prop="truename" label="联系姓名" width="90" align="center"></el-table-column>
	          <el-table-column prop="phone" label="联系电话" width="115" align="center"></el-table-column>
	          <el-table-column prop="bank" label="开户银行" width="110"></el-table-column>
	          <el-table-column prop="rate" label="税率（%）" width="100" align="center"></el-table-column>
	          <el-table-column prop="snumbers" label="关联商品数量" width="105" align="center"></el-table-column>
	          <el-table-column label="操作" width="150" v-if="actionauth.base_product_supplierd_edit=='true' || actionauth.base_product_supplierd_del=='true'" align="center">
		          <template slot-scope="scope">
		              <el-button type="primary" size="small" circle icon="el-icon-edit" @click="editApplyCurrent(scope.row)" v-if="actionauth.base_product_supplierd_edit=='true'"></el-button>
		              <el-button type="danger" size="small" circle icon="el-icon-delete" @click="delApplyCurrent(scope.row)" v-if="actionauth.base_product_supplierd_del=='true'"></el-button>
                  <el-tooltip class="item" effect="dark" :content="scope.row.kingdeesubmit==1 ? '订单数据已同步至金蝶':'将订单数据同步至金蝶'" placement="top" v-if="iskingdee==1">
                      <el-button :type="scope.row.kingdeesubmit==1 ? 'success' : 'primary'" :icon="scope.row.kingdeesubmit==1 ? 'el-icon-check' :  'el-icon-setting'" size="mini" circle @click="kingdeesellsubmit(scope.row)"></el-button>
                  </el-tooltip>
              </template>
	          </el-table-column>
          </el-table>
          <div class="block">
	          <!--分页begin-->
	          <el-pagination
	            @size-change="pageSizeapplyChange"
	            @current-change="pageapplyCurrentChange"
	            :current-page="applyquery.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="applyquery.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="apply_total_rows">
	          </el-pagination>
	          <!--分页end-->
          </div>
	  </div>
	  
	  <!------------------------add apply start---------------------->
      <el-dialog title="新增供应商" :visible.sync="showaddSupplierDialog" top="10vh">
      	  <el-form ref="addsupplyclass" :model="localapply" :rules="classrules" width="60%" size="small">
            <el-col :span="24">
              <el-col :span="12">
	              <el-form-item label="商家名称" prop="name">
	                  <el-col :span="16"><el-input v-model="createapply.apply_name"></el-input></el-col>
	              </el-form-item>
              </el-col>
              <el-col :span="12">
              	  <el-form-item label="公司名称" prop="company">
	                  <el-col :span="18"><el-input v-model="createapply.company"></el-input></el-col>
	              </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="24">
              <el-col :span="12">
	              <el-form-item label="公司税率" prop="rate">
	                  <el-col :span="16">
	                  	  <el-input v-model="createapply.rate">
	                  	      <template slot="append">%</template>
	                  	  </el-input>
	                  </el-col>
	              </el-form-item>
              </el-col>
              <el-col :span="12">
              	  <el-form-item label="公司税号" prop="rateid">
	                  <el-col :span="18"><el-input v-model="createapply.rateid"></el-input></el-col>
	              </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="24">
              <el-col :span="12">
	              <el-form-item label="开户银行" prop="bank">
	                  <el-col :span="16"><el-input v-model="createapply.bank"></el-input></el-col>
	              </el-form-item>
              </el-col>
              <el-col :span="12">
              	  <el-form-item label="银行账号" prop="banknumber">
	                  <el-col :span="18"><el-input v-model="createapply.banknumber"></el-input></el-col>
	              </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="24">
              <el-col :span="12">
	              <el-form-item label="联系姓名" prop="truename">
	                  <el-col :span="16"><el-input v-model="createapply.truename"></el-input></el-col>
	              </el-form-item>
              </el-col>
              <el-col :span="12">
              	  <el-form-item label="联系电话" prop="phone">
	                  <el-col :span="18"><el-input v-model="createapply.phone"></el-input></el-col>
	              </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="24">
	            <el-form-item label="联系地址" prop="address">
	                  <el-col :span="21"><el-input v-model="createapply.address"></el-input></el-col>
	            </el-form-item>
            </el-col>
          </el-form>
      	  
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="showaddSupplierDialog = false">取 消</el-button>
            <el-button size="small" type="primary" :loading="updatesuppleraddLoading" @click="addsupplySave">保 存</el-button>
          </div>
      </el-dialog>
      <!------------------------add apply end------------------------>
      
      <!------------------------edit apply start---------------------->
      <el-dialog title="编辑供应商" :visible.sync="showeditSupplierDialog" top="10vh" width="60%" v-loading="editapplyLoading">
      	  <el-form size="medium">
            <el-col :span="24">
              <el-col :span="12">
	              <el-form-item label="商家名称">
	                  <el-col :span="16"><el-input v-model="editapply.apply_name"></el-input></el-col>
	              </el-form-item>
              </el-col>
              <el-col :span="12">
              	  <el-form-item label="公司名称">
	                  <el-col :span="18"><el-input v-model="editapply.company"></el-input></el-col>
	              </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="24">
              <el-col :span="12">
	              <el-form-item label="公司税率">
	                  <el-col :span="16">
	                  	  <el-input v-model="editapply.rate">
	                  	      <template slot="append">%</template>
	                  	  </el-input>
	                  </el-col>
	              </el-form-item>
              </el-col>
              <el-col :span="12">
              	  <el-form-item label="公司税号">
	                  <el-col :span="18"><el-input v-model="editapply.rateid"></el-input></el-col>
	              </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="24">
              <el-col :span="12">
	              <el-form-item label="开户银行">
	                  <el-col :span="16"><el-input v-model="editapply.bank"></el-input></el-col>
	              </el-form-item>
              </el-col>
              <el-col :span="12">
              	  <el-form-item label="银行账号">
	                  <el-col :span="18"><el-input v-model="editapply.banknumber"></el-input></el-col>
	              </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="24">
              <el-col :span="12">
	              <el-form-item label="联系姓名">
	                  <el-col :span="16"><el-input v-model="editapply.truename"></el-input></el-col>
	              </el-form-item>
              </el-col>
              <el-col :span="12">
              	  <el-form-item label="联系电话">
	                  <el-col :span="18"><el-input v-model="editapply.phone"></el-input></el-col>
	              </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="24">
	            <el-form-item label="联系地址">
	                  <el-col :span="21"><el-input v-model="editapply.address"></el-input></el-col>
	            </el-form-item>
            </el-col>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="showeditSupplierDialog = false">取 消</el-button>
            <el-button size="small" type="primary" :loading="updatesupplereditLoading" @click="editsupplySave">保 存</el-button>
          </div>
      </el-dialog>
      
  </div>
  </transition>   
</template>

<script>

export default {
  data () {
    return {
      actionauth:'', //操作功能权限
      url:this.GLOBAL.domain+"Product/index",
      transitionshow:true,
      applyquery:{
      	url:this.GLOBAL.domain+"Product/index",
        act:'getapplylists',
        token:this.$cookies.get('token'),
        key:'',
        rollpage: 10, // 页大小
        p: 1
      },
      ApplyLoading:false,
      applylists:[],
      apply_total_rows:0,
      applychange:false,
      showSupplierDialog:false,
      showaddSupplierDialog:false,
      classrules: {
        catname: [
            { required: true, message: '请输入分类名称', trigger: 'blur' },
            { min: 1, max: 20, message: '长度在 1 到 20 个字符'}
        ]
      },
      createapply:{
      	  act:'addapply',
      	  token:this.$cookies.get('token'),
      	  apply_name:'',
      	  company:'',
      	  rate:'',
      	  rateid:'',
      	  bank:'',
      	  banknumber:'',
      	  truename:'',
      	  phone:'',
      	  address:'',
      },
      updatesuppleraddLoading:false,
      showeditSupplierDialog:false,
      editapplyLoading:false,
      editapply:{
      	  act:'editapply',
      	  token:this.$cookies.get('token'),
      	  id:'',
      	  apply_name:'',
      	  company:'',
      	  rate:'',
      	  rateid:'',
      	  bank:'',
      	  banknumber:'',
      	  truename:'',
      	  phone:'',
      	  address:'',
      },
      updatesupplereditLoading:false,
      iskingdee:false,
      
    }
  },
  
  mounted(){
  	  this.getactionauth();
	    this.getApplylists(); //供应商管理
      this.checkiskingdee(); //查看当前代理商是否开启金蝶权限 
  },
  
  methods:{
  	
  	/** 获取操作功能权限 **/
  	getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },

    /** 查看当前代理商是否开启了金蝶权限 **/
	  checkiskingdee() {
		    var resource = this.$resource(this.GLOBAL.domain+"kingdee/index");
			  resource.save({act:'isopenkingdee',token:this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					var result = JSON.parse(Base64.decode(res.data.Data));
					this.iskingdee=result.iskingdee;
				}
			}).catch((res) => {
				
			})
    },
    
    /** 获取供应商列表 **/
    getApplylists() {
    	if(this.applychange=='true') {
    		this.applyquery.p=1;
    		this.applyquery.rollpage=10;
    	}
    
    	this.ApplyLoading=true;
        var resource = this.$resource(this.applyquery.url);
        resource.query(this.applyquery).then((res) => {
        	if(res.data.Result>0){
            	if(res.data.Result=='70001'){
                	this.$router.push('/login');
                	this.ApplyLoading=false;
                }
                this.$message.error(res.data.Message);
                this.ApplyLoading=false;
            }else{
				this.applylists=JSON.parse(Base64.decode(res.data.Data));
				this.apply_total_rows=parseInt(res.data.count);
				this.ApplyLoading=false;
            }
            
            if(this.applychange=='true') this.applychange=false;
        }).catch((res) => {
            this.ApplyLoading=false;
        });
    },
    
    pageSizeapplyChange(val) {
    	this.applyquery.rollpage = val;
        this.getApplylists();
    },
    pageapplyCurrentChange(val) {
        this.applyquery.p = val;
        this.getApplylists();
    },
    
    /** 添加供应商名称 **/
    addsupplySave() {
    	this.updatesuppleraddLoading=true;
        var resource = this.$resource(this.applyquery.url);
        resource.query(this.createapply).then((res) => {
        	if(res.data.Result>0){
            	if(res.data.Result=='70001'){
                	this.$router.push('/login');
                	this.updatesuppleraddLoading=false;
                	this.showaddSupplierDialog=false;
                }
                this.$message.error(res.data.Message);
                this.updatesuppleraddLoading=false;
                this.showaddSupplierDialog=false;
            }else{
				this.$message.success('添加供应商：' + this.createapply.apply_name + '成功!');
				this.updatesuppleraddLoading=false;
				this.showaddSupplierDialog=false;
				this.getApplylists();
            }
        }).catch((res) => {
            this.updatesuppleraddLoading=false;
            this.showaddSupplierDialog=false;
        });
    },
    
    /** 编译供应商信息 **/
    editApplyCurrent(obj) {
		this.showeditSupplierDialog=true;
		this.editapplyLoading=true;
		var resource = this.$resource(this.url);
		resource.query({act:'getapplyinfo',token:this.$cookies.get('token'),id:obj.id}).then((res) => {
        	if(res.data.Result>0){
            	if(res.data.Result=='70001') this.$router.push('/login');
                this.$message.error(res.data.Message);
                this.editapplyLoading=false;
            }else{
            	var data=JSON.parse(Base64.decode(res.data.Data));
            	this.editapply.id=data.id;
            	this.editapply.apply_name=data.apply_name;
            	this.editapply.company=data.company;
            	this.editapply.rate=data.rate;
            	this.editapply.rateid=data.rateid;
            	this.editapply.bank=data.bank;
            	this.editapply.banknumber=data.banknumber;
            	this.editapply.truename=data.truename;
            	this.editapply.phone=data.phone;
            	this.editapply.address=data.address;
				this.editapplyLoading=false;
            }
        }).catch((res) => {
        	this.$message.error(this.GLOBAL.errortext);
            this.editapplyLoading=false;
        });
    },
    
    /** 保存编辑供应商信息 **/
    editsupplySave() {
		this.updatesupplereditLoading=true;
    	var resource = this.$resource(this.url);
        resource.query(this.editapply).then((res) => {
        	if(res.data.Result>0){
            	if(res.data.Result=='70001'){
                	this.$router.push('/login');
                	this.updatesupplereditLoading=false;
                	this.showaddSupplierDialog=false;
                }
                this.$message.error(res.data.Message);
                this.updatesupplereditLoading=false;
                this.showeditSupplierDialog=false;
            }else{
				this.$message.success('修改供应商信息成功!');
				this.updatesupplereditLoading=false;
				this.showeditSupplierDialog=false;
				this.getApplylists();
            }
        }).catch((res) => {
        	this.$message.error(this.GLOBAL.errortext);
            this.updatesupplereditLoading=false;
            this.showeditSupplierDialog=false;
        });
    },
    
    //删除供应商信息
    delApplyCurrent(obj) {
    	if(obj.snumbers>0) {
    		this.$message.error("该供应商目前关联有"+obj.snumbers+"个商品，删除该供应商前请先将关联的商品删除！");
    		return false;
    	}
    
    	this.$confirm('此操作将永久删除 ' + obj.apply_name + ', 是否继续?', '提示', { type: 'warning' }).then(() => {
              // 向请求服务端删除
              var resource = this.$resource(this.url);
              resource.save({ act:'delapply',id: obj.id,token:this.$cookies.get('token')}).then((res) => {
                  if(res.data.Result>0){
                      if(res.data.Result=='70001') this.$router.push('/login')
                      this.$message.error(res.data.Message);
                  }else{
                      this.$message.success('成功删除了' + obj.apply_name + '!');
                      this.getApplylists();
                  }
              }).catch((res) => {
                    this.$message.error(this.GLOBAL.errortext);
               });
        }).catch(() => {
        	
        });
    },
    

    /** 将销售员数据提交至金蝶 **/
	  kingdeesellsubmit(item) {
      this.$confirm('警告：操作前请确认供应商信息是否已完结无需修改，数据一经提交至金蝶成功不可撤销', '提示', { type: 'warning' }).then(() => {
            var resource = this.$resource(this.url);
            resource.query({act:'kingdeesubmit',id:item.id,token:this.$cookies.get('token')}).then((res) => {
              if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
              }else{
                this.getApplylists();
                this.$message.success('供应商数据提交到金蝶成功');      
              }
            }).catch((res) => {
                
            });
        }).catch(() => {
                
        });
	  },
    
    
  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
</style>


// WEBPACK FOOTER //
// src/components/inventory/Productsupply.vue